export default __webpack_public_path__ + "static/media/add-file.f7c02377.svg";